import appSettingsApi from "../api/appSettingsApi";

export const types = {
  GET_APP_SETTINGS: 'GET_APP_SETTINGS',
  GET_APP_SETTINGS_SUCCESS: 'GET_APP_SETTINGS_SUCCESS',
  GET_APP_SETTINGS_FAILURE: 'GET_APP_SETTINGS_FAILURE',
};

export const actions = {
  get: () => dispatch => {
    dispatch({ type: types.GET_APP_SETTINGS });
    return appSettingsApi
      .get()
      .then(response => {
        if (response.ok && response.data && response.data.success !== false) {
          return dispatch({ type: types.GET_APP_SETTINGS_SUCCESS, data: response.data });
        }
        dispatch({ type: types.GET_APP_SETTINGS_FAILURE });
      });
  },

}
